import { Link } from "react-router-dom";
import { isProRequiredError } from "../lib/api";

/**
 * Lightweight, reusable nudge for a `pro_required` (HTTP 402) error. Pass any
 * caught error — if it's a Pro-gate error, this renders an inline banner with
 * the feature-specific message and an Upgrade link to /settings; otherwise it
 * renders nothing (return the error to your generic error handler instead).
 *
 * Usage:
 *   const m = useMutation({ mutationFn: gatedAction });
 *   ...
 *   <ProUpgradeNudge error={m.error} />
 */
export function ProUpgradeNudge({ error }: { error: unknown }) {
  if (!isProRequiredError(error)) return null;
  return (
    <div className="rounded-md border border-accent/40 bg-accent/10 px-3 py-2.5 flex items-center gap-3 text-sm">
      <span className="text-fg-1 flex-1">
        {error.message || "This feature is available on Pro."}
      </span>
      <Link
        to="/settings#billing"
        className="shrink-0 px-3 py-1.5 rounded-md bg-accent text-white text-xs font-medium hover:opacity-90"
      >
        Upgrade
      </Link>
    </div>
  );
}
